const isDev = () => {
  return process.env.NODE_ENV === "development";
};

if (isDev()) {
  module.exports = require("./store.dev");
} else {
  module.exports = require("./store.prod");
}
